// src/components/MasterMode/components/Waitlist/Waitlist.tsx
import React, { useState } from 'react';
import './Waitlist.scss';
import { FaPlus, FaClock, FaUtensils, FaCheck, FaRotate } from 'react-icons/fa6';
import ModalAddWaitlist from './components/ModalAddWaitlist/ModalAddWaitlist';
import ModalDeleteWaitLits from './components/ModalDeleteWaitList/ModalDeleteWaitLits';
import { getClientWaitlistByLocalId } from '../../../../../../../crud/clients_api/client_waitlist';
import { FaUserGroup, FaPhone } from 'react-icons/fa6';
import { Spinner } from 'react-bootstrap';

interface WaitlistData {
  waitlists: Array<{
    waitlist_id: number;
    local_id: number;
    local_timestamp: string;
    people: number;
    name: string;
    phone: string;
  }>;
  sorted_mesas: Array<{
    mesa_id: number;
    mesa_number: number;
    wait_time: number;
  }>;
}

interface WaitlistProps {
  waitList?: WaitlistData;
  setWaitList?: (waitList: any) => void;
}

const Waitlist: React.FC<WaitlistProps> = ({ waitList = { waitlists: [], sorted_mesas: [] }, setWaitList }) => {
  // Asegura que waitList y waitList.waitlists siempre existan
  const safeWaitlists = Array.isArray(waitList?.waitlists) ? waitList.waitlists : [];
  const safeSortedMesas = Array.isArray(waitList?.sorted_mesas) ? waitList.sorted_mesas : [];

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [waitlistToDelete, setWaitlistToDelete] = useState<any | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const localId = user?.local_id ?? 0;

  const handleRefresh = async () => {
    if (!setWaitList) return;
    setIsRefreshing(true);
    try {
      const updated = await getClientWaitlistByLocalId(localId);
      setWaitList(updated);
    } catch (error) {
      console.error('Error refreshing waitlist:', error);
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div className="waitlist">
      <div className="waitlist-header">
        <h3 className="waitlist-title">Lista de espera</h3>
        <div className="waitlist-header-actions">
          <div className="waitlist-count">
            {safeWaitlists.length} {safeWaitlists.length === 1 ? 'cliente' : 'clientes'}
          </div>
          <button 
            className="waitlist-reload-btn" 
            onClick={handleRefresh}
            disabled={isRefreshing}
            title="Actualizar tiempos de espera"
          >
            {isRefreshing ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <FaRotate />
            )}
          </button>
        </div>
      </div>

      <div className="container-waitlist">
        {safeWaitlists.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">🪑</div>
            <div className="empty-message">No hay clientes en espera</div>
            <div className="empty-description">Agrega clientes a la lista de espera cuando no existan mesas disponibles</div>
          </div>
        ) : (
          safeWaitlists.map((cliente, idx) => {
            const mesa = safeSortedMesas[idx];
            const mesaDisponible = mesa
              ? { num: mesa.mesa_number, wait_time: mesa.wait_time }
              : null;
            
            return (
              <div key={cliente.waitlist_id || idx} className="card-waitlist">
                <div className="card-waitlist_content">
                  <div className="waitlist-card-header">
                    <div className="customer-name">{cliente.name || 'Sin nombre'}</div>
                    <div className="people-count">
                      <FaUserGroup className="people-icon" />
                      <span>{cliente.people || 1}</span>
                    </div>
                    <div className="wait-time">
                      <FaClock className="icon" />
                      {mesaDisponible ? `${mesaDisponible.wait_time} min` : '0 min'}
                    </div>
                  </div>
                  
                  <div className="card-body">
                    <div className="customer-info">
                      <div className="info-item">
                        <FaPhone className="info-icon" />
                        <span>{cliente.phone || 'Sin teléfono'}</span>
                      </div>
                      
                      {mesaDisponible && (
                        <div className="suggested-table">
                          <FaUtensils className="table-icon" />
                          <span className="table-text">Mesa #{mesaDisponible.num}</span>
                        </div>
                      )}
                    </div>
                    
                    <button 
                      className="complete-btn"
                      onClick={() => { setWaitlistToDelete(cliente); setShowDeleteModal(true); }}
                      title="Marcar como completado"
                    >
                      <FaCheck className="check-icon" />
                      <span>Listo</span>
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      <div className="waitlist-action">
        <button className="btn-add-waitlist" onClick={() => setShowAddModal(true)}>
          <FaPlus className="add-icon" />
          <span>Agregar a la lista de espera</span>
        </button>
      </div>

      <ModalAddWaitlist
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        setWaitList={setWaitList}
        waitList={safeWaitlists}
        getClientWaitlistByLocalId={getClientWaitlistByLocalId}
        localId={localId}
      />
      <ModalDeleteWaitLits
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        waitlist={waitlistToDelete}
        setWaitList={setWaitList}
        waitList={safeWaitlists}
        getClientWaitlistByLocalId={getClientWaitlistByLocalId}
        localId={localId}
      />
    </div>
  );
};

export default Waitlist;
